export function userNeedsJobBoardProfileCompletion(
  userData: { rols?: { name?: string }[]; type?: string | null } | null | undefined
): boolean {
  if (!userData?.rols?.length) return false;
  const isJobBoard = userData.rols.some((r) => r?.name === "JOBBOARD");
  if (!isJobBoard) return false;
  return userData.type == null;
}
